import { DateTime } from "luxon";
import type { CartLine, OrderDetail } from "./orderingApi";

function singleLine(value: string) {
  return value.replace(/\s+/g, " ").trim();
}

function formatLine(line: {
  brand: string;
  commercialName: string;
  supplierReference: string;
  manufacturerReference: string;
  quantity: number;
}) {
  const label = [line.brand, line.commercialName]
    .map(singleLine)
    .filter(Boolean)
    .join(" · ");
  return [
    `${line.quantity} × ${label}`,
    `    Référence revendeur : ${singleLine(line.supplierReference)}`,
    ...(line.manufacturerReference.trim()
      ? [`    Référence fabricant : ${singleLine(line.manufacturerReference)}`]
      : []),
  ].join("\n");
}

export function formatCartText(cart: CartLine[]) {
  const suppliers = new Map<string, { name: string; lines: CartLine[] }>();
  for (const line of cart) {
    const supplier = suppliers.get(line.supplierId);
    if (supplier) supplier.lines.push(line);
    else
      suppliers.set(line.supplierId, {
        name: line.supplierName,
        lines: [line],
      });
  }
  return Array.from(suppliers.values())
    .map(
      (supplier) =>
        `Revendeur : ${singleLine(supplier.name)}\n\n${supplier.lines.map(formatLine).join("\n\n")}`,
    )
    .join("\n\n--------------------\n\n");
}

export function formatOrderText({ order, lines }: OrderDetail) {
  return [
    `Revendeur : ${singleLine(order.supplierName)}`,
    `Commande du ${DateTime.fromISO(order.orderedAt).toFormat("dd/MM/yyyy HH:mm")}`,
    ...lines.map((line) =>
      formatLine({ ...line, quantity: line.orderedQuantity }),
    ),
  ].join("\n\n");
}
